export default __webpack_public_path__ + "images/cotoha-call-center-logo-square.svg";